import { Instagram, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo-negocio-conectado.webp";

const Footer = () => (
  <footer id="contato" className="bg-brand-dark py-12 md:py-16">
    <div className="container">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <img src={logo} alt="Negócio Conectado" width={256} height={80} loading="lazy" className="mb-4 h-10 w-auto brightness-0 invert" />
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-primary-foreground/80">
            Contato
          </h3>
          <div className="space-y-3">
            <p className="text-sm text-primary-foreground/60">
              Av. Viêira de Brito, 399 C - São Cristóvão<br />
              Palmeira dos Índios - AL, 57601-100
            </p>
            <p className="text-sm text-primary-foreground/60">
              CNPJ: 20.927.311/0001-08
            </p>
          </div>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-primary-foreground/80">
            Redes Sociais
          </h3>
          <a
            href="https://www.instagram.com/negocioconectado/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-primary-foreground/60 transition-colors hover:text-primary"
          >
            <Instagram className="h-5 w-5" />
            @negocioconectado
          </a>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 border-t border-primary-foreground/10 pt-6 text-sm">
        <Link to="/sobre" className="text-primary-foreground/60 hover:text-primary">Sobre</Link>
        <Link to="/contato" className="text-primary-foreground/60 hover:text-primary">Contato</Link>
        <Link to="/blog" className="text-primary-foreground/60 hover:text-primary">Blog</Link>
        <Link to="/politica-de-privacidade" className="text-primary-foreground/60 hover:text-primary">Política de Privacidade</Link>
        <Link to="/termos-de-uso" className="text-primary-foreground/60 hover:text-primary">Termos de Uso</Link>
      </div>

      <div className="mt-6 border-t border-primary-foreground/10 pt-6 text-center text-xs text-primary-foreground/40">
        © {new Date().getFullYear()} Negócio Conectado. Todos os direitos reservados.
      </div>
    </div>
  </footer>
);

export default Footer;
